'use strict';

var formsApp = function () {
  var vehicle = void 0;
  var _setCurrentDealersVehicle = function _setCurrentDealersVehicle(value) {
    return vehicle = value;
  };
  var _getCurrentDealersVehicle = function _getCurrentDealersVehicle() {
    return vehicle;
  };

  var _fillHiddenInputs = function _fillHiddenInputs() {
    var vehicle = _getCurrentDealersVehicle().vehicle;
    var dealersVehicle = _getCurrentDealersVehicle();

    var codcom = vehicle.vcodcom17;
    if (sessionStorage.cafi) {
      var cafiData = JSON.parse(sessionStorage.cafi);
      if (cafiData[codcom]) {
        var financialObj = cafiData[codcom];
        $('input[name="pcuota"]').val(financialObj.cuota_financiera);
        $('input[name="pduracion"]').val(financialObj.duracion);
        $('input[name="pentrada"]').val(financialObj.entrada);
        $('input[name="pultimaCuota"]').val(financialObj.ultima_cuota);
      }
    }

    var pricesToSend = {
      pvp: Math.round(parseFloat(dealersVehicle.prices.precioMostrar)),
      offer: Math.round(parseFloat(dealersVehicle.prices.precioOferta))
    };
    $('input[name="pavisoLegalCheck"]').on('click', function () {
      $('input[name="pavisoLegal"]').val($(this).prop('checked') ? 1 : 0);
    });
    $('input[name="pcodComercial"]').val(dealersVehicle.vcodCom);
    $('input[name="pPVP"]').val(pricesToSend.pvp);
    $('input[name="pPVPConOferta"]').val(pricesToSend.offer);
    $('input[name="pacciones"]').val(dealersVehicle.prices.oferta.vacciones);
    $('input[name="pcid"]').val(window.sessionStorage.getItem('cid'));
    $('input[name="putmSource"]').val(window.sessionStorage.getItem('utmSource'));
    $('input[name="putmMedium"]').val(window.sessionStorage.getItem('utmMedium'));
    $('input[name="putmCampaign"]').val(window.sessionStorage.getItem('utmCampaign'));
  };

  var _init = function _init(params) {
    _setCurrentDealersVehicle(vehicleData.dealersVehicles[0]);
    var dealersVehicle = _getCurrentDealersVehicle();
    vehicleApp.setCurrentVehicle(dealersVehicle.vehicle);
    vehicleApp.setCurrentPrices(dealersVehicle.prices);

    /* vehicleApp.displayGeneralData()
    vehicleApp.displayImages() */

    var formValidate = new PlanSimpleValidator(params.selector, params.options);

    _fillHiddenInputs();
  };

  return {
    init: _init
  };
}();